<template>
    <div>
        <b-button-group>
            <button type="submit" class="btn btn-rose" v-bind:disabled="disabledSave">
                <span class="btn-label">
                    <i class="material-icons">done</i>
                </span>
                {{ textSave ? textSave : 'Salvar' }}
            </button>
            <router-link v-if="toBack" tag="button" :to="toBack" class="btn">
                <span class="btn-label">
                    <i class="material-icons">{{ iconBack ? iconBack : 'keyboard_arrow_left' }}</i>
                </span>
                {{ textBack ? textBack : 'Voltar' }}
            </router-link>
            <button type="button" v-if="toBackAuto" v-on:click="() => {this.$router.back()}" class="btn">
                <span class="btn-label">
                    <i class="material-icons">keyboard_arrow_left</i>
                </span>
                {{ 'Voltar' }}
            </button>
            <slot />
        </b-button-group>
    </div>
</template>
<script>
    export default {
        props: ['toBack', 'iconBack', 'textBack', 'textSave', 'toBackAuto', 'disabledSave']
    }
</script>
